"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeDuplicatePrimitives = void 0;
function removeDuplicatePrimitives(arr) {
    return [...new Set(arr)];
}
exports.removeDuplicatePrimitives = removeDuplicatePrimitives;
//# sourceMappingURL=removeDuplicatePrimitives.js.map